export const UserRole = {
  NONE: "none",
  SHOP: "shop",
  CUSTOMER: "customer",
  ADMIN: "admin",
} as const;
export type UserRoleType = (typeof UserRole)[keyof typeof UserRole];
